module.exports = __webpack_public_path__ + "img/subBanner21.946d074c.png";